<template>
  <div class="selector">
    <ul class="selector__tabs selector__tabs--pants">
      <li
        class="selector__tabs__item"
        v-for="area in data.areas"
        :key="area.id"
      >
        <button
          :class="area.id === selectedArea.id && 'is-current'"
          @click="changeArea(area)"
        >
          <span>
            <ThumbAreaPants :name="area.slug" :current="area.id === selectedArea.id"  />
          </span>
          {{ area.name }}
        </button>
      </li>
    </ul>
    <div class="selector__wrapper">
      <div class="selector__container">
        <!-- エレメント -->
        <div class="items items--pantsElements">
          <div class="items__item" v-for="element in currentElements" :key="element.id">
            <button
              :class="`items__button ${ isSelected(element) && 'is-selected' }`"
              @click="handleChangeElement(element)"
            >
              <span class="items__thumb"><PantsElementImage :name="element.slug" /></span>
              <span class="items__name">{{ element.name }}</span>
            </button>
          </div>
        </div>
        <!-- ベース -->
        <div v-if="selectedArea.slug === 'base' && isContainElementSlug('stripe')" class="items items--pantsItems">
          <div class="items__item" v-for="item in stripeItems" :key="item.id">
            <button
              @click="changeBaseItem(item)"
              :class="`items__button ${ item.id === selectedBaseItem.id && 'is-selected' }`"
            >
              <span class="items__thumb"><PantsItemImage name="stripe" :color="item.color" /></span>
            </button>
          </div>
        </div>
        <!-- 装飾 -->
        <template v-if="selectedArea.slug === 'decoration'">
          <div v-if="isContainElementSlug('switch')" class="items items--pantsItems">
            <div class="items__item" v-for="item in switchItems" :key="item.id">
              <button
                @click="changeDecorateItem(item)"
                :class="`items__button ${ item.id === selectedDecorateItem.id && 'is-selected' }`"
              >
                <span class="items__thumb"><PantsItemImage :name="item.slug" color="#636360" /></span>
              </button>
            </div>
          </div>
          <div class="items items--colors">
            <div class="items__item">
              <button
                :class="`items__button is-none ${ 'transparent' === selectedDecorateColor && 'is-selected' }`"
                @click="changeDecorateItemColor('transparent')"
              >
                <span>なし</span>
              </button>
            </div>
            <div class="items__item" v-for="color in colors" :key="color">
              <button
                :style="{ backgroundColor: color }"
                :class="`items__button ${ color === selectedDecorateColor && 'is-selected' }`"
                @click="changeDecorateItemColor(color)"
              >
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ThumbAreaPants from '../images/thumb/area/pants/ThumbAreaPants'    // パンツのエリア画像
import PantsElementImage from '../images/item/PantsElementImage'
import PantsItemImage from '../images/item/PantsItemImage'
import { mapState, mapMutations } from 'vuex'
export default {
  components: {
    ThumbAreaPants,
    PantsElementImage,
    PantsItemImage
  },
  computed: {
    ...mapState({
      data: state => state.pants.data,
      colors: state => state.pants.colors,
      selectedArea: state => state.pants.selectedArea,
      selectedElement: state => state.pants.selectedElement,
      selectedBaseItem: state => state.pants.selectedBaseItem,
      selectedDecorateItem: state => state.pants.selectedDecorateItem,
      selectedDecorateColor: state => state.pants.selectedDecorateColor,
    }),
    currentElements: function() { 
      return this.data.elements.filter(element => element.area_id === this.selectedArea.id)
    },
    stripeItems: function() {
      return this.data.items.filter(item => {
        const targetElement = this.data.elements.find(element => element.slug === 'stripe')
        return item.element_id === targetElement.id
      })
    },
    switchItems: function() {
      return this.data.items.filter(item => {
        const targetElement = this.data.elements.find(element => element.slug === 'switch')
        return item.element_id === targetElement.id
      })
    }
  },
  methods: {
    ...mapMutations({
      changeArea: 'pants/changeArea',
      changeElement: 'pants/changeElement',
      changeBaseItem: 'pants/changeBaseItem',
      changeDecorateItem: 'pants/changeDecorateItem',
      changeDecorateItemColor: 'pants/changeDecorateItemColor',
    }),
    handleChangeElement: function(element) {
      this.changeElement(element)
      if (element.slug === 'plain') {
        const plainItem = this.data.items.find(item => item.slug === 'plain')
        this.changeBaseItem(plainItem)
      }
      if (element.slug === 'line') {
        const plainItem = this.data.items.find(item => item.slug === 'line')
        this.changeDecorateItem(plainItem)
      }
    },
    isSelected: function(_element) {
      return this.selectedElement.find(element => element.id === _element.id)
    },
    isContainElementSlug: function(slug) {
      return this.selectedElement.find(element => element.slug === slug)
    }
  }
}
</script>